<template>
    <div>
        <!-- <el-input ref="spinput" :value="valueStr" :placeholder="placeholder" clearable @clear="onClear" autocomplete="off" style="width:95%" @focus="on选择商品()"></el-input> -->

        <elModal ref="商品选择对话框">
            <div style="height:400px;max-height:600px;overflow: auto;position: relative;min-width:600px;">
                <div style="margin-bottom: 5px;background: gray;padding: 5px;">
                    <el-input type="text" size="small" style="width: 230px;margin-top: 5px;margin-left: 10px;" placeholder="名称搜索" v-model="搜索str" @focus="e=>e.currentTarget.select()">
                        <template slot="prepend">搜索:</template>
                    </el-input>
                </div>
                <ul>
                    <li v-for="(lb,index) in 商品类别list" :key="index">
                        <div v-if="过滤商品list.Where(a=>a.I_商品类别编号==lb.I_商品类别编号).length>0">
                            <div style="margin-bottom: 5px;background: lightgray;padding: 5px;">
                                {{lb.C_商品类别名称}}
                                <el-button v-if="multiple" type="warning" size="small" @click="()=>{filter过滤商品list.Where('$.I_商品类别编号=='+lb.I_商品类别编号).forEach(e=>{e.checked=true;})}">全选</el-button>
                                <el-button v-if="multiple" type="warning" size="small" @click="()=>{商品list.Where('$.I_商品类别编号=='+lb.I_商品类别编号).forEach(e=>{e.checked=false;})}">全不选</el-button>
                            </div>
                            <ul>
                                <li v-for="(cp,index2) in 过滤商品list.Where(a=>a.I_商品类别编号==lb.I_商品类别编号)" :key="index+'cp'+index2" style="display:inline-block;margin-right: 5px;margin-bottom: 5px;">
                                    <el-button style="min-width:100px;" class="longtext" :icon="cp.checked?'el-icon-check':''" :type="cp.checked?'primary':''" size="small" @click="()=>{if(multiple){cp.checked=!cp.checked}else{cp.checked=true;$refs.商品选择对话框.submit()}}">{{cp.C_商品名称}}</el-button>
                                </li>
                            </ul>
                        </div>
                    </li>
                </ul>
            </div>
        </elModal>
    </div>
</template>

<script>
import { mapState2, mapActions } from "vuex-ext";

export default {
    props: {
        value: {
            type: Array,
            default: () => []
        },
        title: {
            type: String,
            default: '选择商品'
        },
        filter: {
            type: String,
            default: ''
        },
        placeholder: {
            type: String,
            default: '请选择商品'
        },
        multiple: {
            type: Boolean,
            default: true,
        },
        //自定义
        customValue: {
            type: String,
            default: ''
        },
        商品类别list: {
            type: Array,
            default: () => []
        }
    },
    computed: {
        ...mapState2(['商品list']),
        filter过滤商品list() {
            let list = this.商品list;

            if (this.filter == '非套餐') list = list.Where(a => a.J_商品参数.J_套餐组成.length < 1);
            else if (this.filter) list = list.Where(this.filter);

            return list;
        },
        过滤商品list() {
            let list = this.商品list;

            if (this.filter == '非套餐') list = list.Where(a => a.J_商品参数.J_套餐组成.length < 1);
            else if (this.filter) list = list.Where(this.filter);

            if (this.搜索str) {
                let 搜索输入 = this.搜索str.toLowerCase();
                list = list.Where(a => (a.C_商品名称 || '').includes(搜索输入) || (a.C_简拼 || '').includes(搜索输入) || (a.C_点菜宝编号 || '').includes(搜索输入));
                //list = list.Where('($.C_商品名称||"").includes("' + 搜索输入 + '") || ($.C_简拼||"").includes("' + 搜索输入 + '") || ($.C_点菜宝编号||"").includes("' + 搜索输入 + '")')
            }

            return list;
        },
        valueStr() {
            if (this.customValue) return this.customValue;
            let length = (this.value || []).length;
            if (length == 0) return '全部商品';
            else return length + '个商品';
        }
    },
    data() {
        return {
            搜索str: '',
        }
    },
    mounted() {
        this.获取商品();
    },
    methods: {
        ...mapActions(['获取商品']),
        async on选择商品() {
            try {
                let selectList = await this.fun选择商品(this.value);
                this.$emit('input', selectList.Select(a => {
                    return {
                        I_商品编号: a.I_商品编号,
                        C_商品名称: a.C_商品名称,
                    }
                }));
            } catch (error) {
                this.$refs.spinput.blur();
                this.$Alert(error);
            }
        },
        async fun选择商品(value = []) {
            if (this.商品list.length < 1) throw '没有商品可以选择!';
            this.商品list.forEach(e => { this.$set(e, 'checked', value.Any(a => a.I_商品编号 == e.I_商品编号)); });

            await this.$refs.商品选择对话框.show({
                title: this.title,
                showCustomButton: true,
                customButtonText: '全部商品',
                customClick: () => {
                    this.商品list.forEach(e => { this.$set(e, 'checked', false); });
                    this.$refs.商品选择对话框.submit();
                },
                beforeClose: () => {
                    try {
                        let 选择菜品 = this.商品list.Where('$.checked');
                        //if (选择菜品.length < 1) throw '请选择商品!';
                        return true;
                    } catch (error) {
                        this.$Alert(error);
                    }
                    return false;
                }
            });

            let selectList = this.商品list.Where('$.checked');
            if (!this.multiple) {
                return selectList[0];
            }
            return selectList;
        },
        onClear() {
            this.$emit('input', []);
        },
    }
}
</script>

<style>
</style>